// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";

import emailValidator from "./validators/email";
import fileValidator from "./validators/file";
import fioValidator from "./validators/fio";
import humanDateValidator from "./validators/human-date";
import idNumberLocationZaValidator from "./validators/id-number-location-za";
import idnpValidator from "./validators/idnp";
import imeiValidator from "./validators/imei";
import innValidator from "./validators/inn";
import phoneValidator from "./validators/phone";
import serialValidation from "./validators/serial";
import seriasAndNumberMDValidator from "./validators/serias-and-number-md";

type I_UseValidate_Params = {
    target:
        | "imei"
        | "fio"
        | "inn"
        | "idnp"
        | "email"
        | "phone"
        | "file"
        | "human-date"
        | "id-number--location-za"
        | "serias-and-number-md"
        | "serial";
    value: string | HTMLInputElement;
};

export type I_UseValidate_Return = {
    status: boolean;
    message: string;
};

/** Верхнеуровневая функция-валидатор */
export default function useValidate({ target, value }: I_UseValidate_Params): I_UseValidate_Return {
    switch (target) {
        case "serial": {
            return serialValidation(value as string);
        }
        case "imei": {
            return imeiValidator(value as string);
        }
        case "file": {
            return fileValidator(value as HTMLInputElement);
        }
        case "fio": {
            return fioValidator(value as string);
        }
        case "inn": {
            return innValidator(value as string);
        }
        case "idnp": {
            return idnpValidator(value as string);
        }
        case "email": {
            return emailValidator(value as string);
        }
        case "phone": {
            return phoneValidator(value as string);
        }
        case "human-date": {
            return humanDateValidator(value as string);
        }
        case "id-number--location-za": {
            return idNumberLocationZaValidator(value as string);
        }
        case "serias-and-number-md": {
            return seriasAndNumberMDValidator(value as string);
        }
        default:
            return {
                status: false,
                message: useTranslate("tiw__validation__undefined"),
            };
    }
}
